import React from "react";
import { Table, Column, Label } from "lib/components";
import { PropertyEditor } from "./PropertyEditor";
import { PropertyKeyLabel } from "./PropertyKeyLabel";
import { findDesignerComponent } from "./FindDesignerComponent";
import { ToolDefs } from "./Tools";
import { getLogger } from "lib/util";

const log = getLogger("designer.PropertiesTable");

export function PropertiesTable({ selectedComponents, propertiesChanged, content, ...props }) {
  if (selectedComponents == null || selectedComponents.length === 0)
    return <Label caption="No components selected" align="center" marginTop={16} color="rgb(180, 180, 180)" fillRow />
  let data;
  if (content != null)
    data = getTableData(content, selectedComponents);
  return (
    <Table data={data} fillRow headerVisible={false} columnHeadingsVisible={false} rowSpacing={0} alternateRowColor {...props} >
      <Column caption="Name" cellStyles={{borderRight:"1px solid #DDDDDD"}}>
        <PropertyKeyLabel />
      </Column>

      <Column caption="Value" cellStyles={{paddingRight:0}}>
        <PropertyEditor content={content} selectedComponents={selectedComponents} propertiesChanged={propertiesChanged} />
      </Column>
    </Table>
  );
}

function getPropTypesForComponents(comps) {
  if (comps == null || comps.length === 0)
    return null;
  const toolDef = ToolDefs[comps[0].type];
  if (toolDef == null) {
    log.error("ToolDef for " + comps[0].type + " was not found.");
    return [];
  }
  let result = toolDef.type.extPropTypes;
  for (let i = 1; i < comps.length; i++) {
    let thisProps = ToolDefs[comps[i].type].type.extPropTypes;
    let del = [];
    for (let propName in result)
      if (thisProps[propName] === undefined)
        del.push(propName);
    for (let j = 0; j < del.length; j++)
      delete result[del[i]];
  }
  log.debug("Prop types: %o   %o", result, toolDef);
  return result;
}

function getTableData(content, selectedComponents) {
  let compProps = [];
  for (let i = 0; i < selectedComponents.length; i++) {
    let props = findDesignerComponent(content, selectedComponents[i]);
    if (props != null)
      compProps.push(props);
  }
  let propTypes = getPropTypesForComponents(compProps);

  let result = [];
  for (let prop in propTypes) {
    let propValue = compProps[0][prop];
    const thisPropType = propTypes[prop]
    let containsDefaultValue = propValue === undefined
      || propValue === thisPropType.defaultValue
      || (propValue == null && thisPropType.defaultValue === undefined)
      || (propValue === false && thisPropType.defaultValue === undefined)
      || (propValue === "" && thisPropType.defaultValue === undefined);
    result.push({ key: prop, containsDefaultValue, value: propValue, propType: thisPropType });
  }
  result.sort((object1, object2) => {
    const key1 = object1.key;
    const key2 = object2.key;
    if (key1 === "name" && key2 === "name")
      return 0;
    else if (key1 === "name")
      return -1;
    else if (key2 === "name")
      return 1;
    else
      return key1.localeCompare(key2);
  });
  return result;
}
